import { render, staticRenderFns } from "./learningDetail.vue?vue&type=template&id=66ba21c6&scoped=true&"
import script from "./learningDetail.vue?vue&type=script&lang=js&"
export * from "./learningDetail.vue?vue&type=script&lang=js&"
import style0 from "./learningDetail.vue?vue&type=style&index=0&id=66ba21c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ba21c6",
  null
  
)

export default component.exports